import { FunctionComponent, h } from 'preact';

import { MyAccountEmptyStatePropsInterface } from './props.interface';

export const MyAccountEmptyStateTemplate: FunctionComponent<MyAccountEmptyStatePropsInterface> = ({
  icon,
  title,
  description,
  children,
}) => (
  <div className='empty-state__container'>
    <div className='empty-state__icon-container'>{icon}</div>
    <span className='empty-state__title'>{title}</span>
    <span className='empty-state__description'>{description}</span>
    {children}
  </div>
);
